import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import aboutus_img from "../images/aboutus.png";
import ClientCards from "./ClientCards";

const AboutUs = () => {
  return (
    <Container
      maxWidth="100%"
      sx={{
        width: "90%",
        padding: { xs: 0.2, sm: 0.5, md: 0.8, lg: 1, xl: 1.2 }, // Responsive padding
      }}
    >
      {/* About Us Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            sm: "column",
            md: "column",
            lg: "row",
            xl: "row",
          }, // Stack on mobile and small screens, row on md and larger
          justifyContent: "center", // Center the entire section horizontally
          alignItems: "center", // Center vertically on mobile/small screens
          gap: { xs: 2, sm: 3, md: 4 }, // Responsive gap
          marginY: { xs: 2, sm: 4, md: 6 }, // Responsive margin
          backgroundColor: "#FFFFFF", // Light grey background for consistency
          borderRadius: 3,
          padding: { xs: 1, sm: 2, md: 2, lg: 2, xl: 3 }, // Responsive padding
          border: "1px solid rgba(56, 55, 55, 0.2)",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        {/* About Us Image */}
        <Box
          sx={{
            width: { xs: "100%", sm: "80%", md: "80%", lg: "80%", xl: "80%" }, // Full width on mobile/small, 50% on md and larger
            display: "flex",
            justifyContent: "center", // Center the image horizontally
            alignItems: "center", // Center vertically
            padding: { xs: 1, sm: 1, md: 1, lg: 2, xl: 2 },
          }}
        >
          <Box
            component="img"
            src={aboutus_img}
            alt="About Us"
            sx={{
              width: "100%",
              borderRadius: 2,
              // height: "800px",
            }}
            justifySelf={"center"}
          />
        </Box>

        {/* About Us Text */}
        <Box
          sx={{
            width: { xs: "100%", sm: "80%", md: "80%", lg: "60%", xl: "70%" }, // Full width on mobile/small, 50% on md and larger
            padding: { xs: 1, sm: 1, md: 1, lg: 2, xl: 2 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Center text vertically on mobile/small screens
            alignItems: "center", // Center text horizontally on mobile/small screens
          }}
        >
          <Typography
            variant="h3"
            sx={{
              color: "#002367",
              fontFamily: "Light",
              fontWeight: "700",
              fontSize: { xs: 20, sm: 24, md: 28, lg: 32, xl: 36 }, // Responsive font size
              marginBottom: { xs: 1, sm: 2, md: 2, lg: 3, xl: 3 },
              textAlign: "center", // Center-align text on all screens
            }}
          >
            Who We Are
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#002367",
              fontFamily: "Light",
              fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 }, // Responsive font size
              marginBottom: { xs: 1, sm: 2, md: 2, lg: 2, xl: 3 },
              textAlign: "start", // Center-align text on all screens
            }}
          >
            <strong>Shri Sai Tech</strong> understands how crucial it is to find
            the right employee with the right skill sets who can contribute to
            the success of your business. Whether you are a small business or a
            large corporate with your own HR department, finding the right
            people is never easy. This is where we can help.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#002367",
              fontFamily: "Light",
              fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 }, // Responsive font size
              marginBottom: { xs: 1, sm: 2, md: 2, lg: 2, xl: 3 },
              textAlign: "start", // Center-align text on all screens
            }}
          >
            We have a workforce that is spread all over USA with just one
            mission to fulfil – finding the right people to meet your specific
            needs. You may need people with a certain level of experience in a
            particular domain, or in a specific location. No matter what you
            require, our competent staffing services division will find people
            who will meet the unique needs of your company.
          </Typography>
          <Typography
            variant="h3"
            sx={{
              color: "#002367",
              fontFamily: "Light",
              fontWeight: "700",
              fontSize: { xs: 20, sm: 20, md: 24, lg: 28, xl: 30 }, // Responsive font size
              marginBottom: { xs: 1, sm: 2, md: 2, lg: 3, xl: 3 },
              textAlign: "center", // Center-align text on all screens
            }}
          >
            About LLM Insight
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#002367",
              fontFamily: "Light",
              fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 }, // Responsive font size
              marginBottom: { xs: 1, sm: 2, md: 2, lg: 2, xl: 3 },
              textAlign: "start", // Center-align text on all screens
            }}
          >
            <strong>LLM Insight</strong> is a{" "}
            <strong>cutting-edge AI governance platform</strong> built to{" "}
            <strong>
              monitor, manage, and optimize Large Language Models (LLMs)
            </strong>{" "}
            with precision. As AI adoption grows, organizations need{" "}
            <strong>robust solutions</strong> to ensure
            <strong> cost-efficiency, security, and compliance</strong> in LLM
            usage.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#002367",
              fontFamily: "Light",
              fontSize: { xs: 12, sm: 12, md: 14, lg: 16, xl: 18 }, // Responsive font size
              marginBottom: { xs: 1, sm: 2, md: 2, lg: 2, xl: 3 },
              textAlign: "left", // Center-align text on all screens
            }}
          >
            Our mission is to <strong>simplify LLM governance</strong> for
            businesses by providing:
          </Typography>
          <List
            sx={{
              listStyle: "none",
              padding: 0,
              width: "100%", // Full width for centering
              textAlign: "left", // Center-align the list items
            }}
          >
            {[
              "📊 <strong>Real-time analytics</strong> for AI usage & performance.",
              "💰 <strong>Automated cost tracking</strong> to prevent overspending.",
              "🔄 <strong>A unified chat interface</strong> for multiple LLM providers.",
              "⚙️ <strong>Scalability & modularity</strong> through microservices.",
              "📂 <strong>Centralized logging</strong> for auditing & compliance.",
            ].map((item, index) => (
              <ListItem
                key={index}
                sx={{
                  textAlign: "center", // Center-align each item
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#002367",
                        fontFamily: "Light",
                        fontSize: { xs: 12, sm: 12, md: 14, lg: 16, xl: 18 }, // Responsive font size
                        textAlign: "start", // Center-align text on all screens
                      }}
                      dangerouslySetInnerHTML={{ __html: item }}
                    />
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>

      {/* Why Choose LLM Insight */}
      <Box
        sx={{
          marginY: { xs: 2, sm: 4, md: 6 }, // Responsive margin
          padding: { xs: 1, sm: 2, md: 3 }, // Responsive padding
          backgroundColor: "#FFFFFF", // Light grey background for consistency
          borderRadius: 2,
          border: "1px solid rgba(56, 55, 55, 0.2)",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center", // Center the section horizontally
          alignItems: "center", // Center vertically on mobile/small screens
        }}
      >
        <Typography
          variant="h3"
          sx={{
            color: "#002367",
            fontFamily: "Light",
            fontWeight: "700",
            fontSize: { xs: 20, sm: 24, md: 28, lg: 32, xl: 36 }, // Responsive font size
            marginBottom: { xs: 1, sm: 2, md: 2, lg: 3, xl: 3 },
            textAlign: "center", // Center-align text on all screens
          }}
        >
          Why Choose LLM Insight?
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#002367",
            fontFamily: "Light",
            fontSize: { xs: 12, sm: 12, md: 14, lg: 16, xl: 18 }, // Responsive font size
            marginBottom: { xs: 1, sm: 2, md: 2, lg: 2, xl: 3 },
            textAlign: "start", // Center-align text on all screens
          }}
        >
          <strong>LLM Insight</strong> provides a{" "}
          <strong>powerful AI governance framework</strong>, ensuring that your
          AI systems are{" "}
          <strong>cost-effective, secure, and seamlessly integrated</strong>.
          Here’s why companies trust us:
        </Typography>
        <List
          sx={{
            listStyle: "none",
            padding: 0,
            width: "100%", // Full width for centering
            textAlign: "center", // Center-align the list items
          }}
        >
          {[
            "📊 <strong>Cost Monitoring & Budget Control</strong> - Track expenses in <strong>real-time</strong>.",
            "🔒 <strong>Security & Compliance</strong> - Integrated with <strong>Active Directory</strong> for role-based access.",
            "🖥️ <strong>Single Chat Window</strong> - Unified interface for <strong>all LLM providers</strong>.",
            "⚙️ <strong>Microservices Architecture</strong> - Ensures <strong>scalable AI model deployments</strong>.",
            "📂 <strong>Centralized LLM Usage Logs</strong> - Maintain <strong>detailed records for audits</strong>.",
          ].map((item, index) => (
            <ListItem
              key={index}
              sx={{
                textAlign: "center", // Center-align each item
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#002367",
                      fontFamily: "Light",
                      fontSize: { xs: 12, sm: 12, md: 14, lg: 16, xl: 18 }, // Responsive font size
                      textAlign: "start", // Center-align text on all screens
                    }}
                    dangerouslySetInnerHTML={{ __html: item }}
                  />
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>
      <ClientCards />
    </Container>
  );
};

export default AboutUs;

// import React from "react";
// import { Box, Container, Typography, Grid2, Avatar } from "@mui/material";
// import img from "../images/aboutus.png";
// import trikaLogo from "../images/trika_technologies_logo.jpeg";
// import conceptvinesLogo from "../images/conceptvines-logo.jpg";
// import elemrexLogo from "../images/elemrexlogo.png";
// import ClientCards from "./ClientCards";

// const AboutUs = () => {
//   return (
//     <Box>
//       {/* About Us Section */}
//       <Container
//         maxWidth="100%"
//         sx={{
//           width: "90%",
//           padding: { xs: 0.2, sm: 0.5, md: 0.8, lg: 1, xl: 1.2 }, // Responsive padding
//         }}
//       >
//         <Grid2 container spacing={4} alignItems="center">
//           {/* About Us Image */}
//           <Grid2 item xs={12} md={6}>
//             <Box
//               component="img"
//               src={img}
//               alt="About Us"
//               sx={{ width: "100%", borderRadius: 2 }}
//             />
//           </Grid2>

//           {/* About Us Text */}
//           <Grid2 item xs={12} md={6}>
//             <Typography variant="h4" color="primary" gutterBottom>
//               Who We Are
//             </Typography>
//             <Typography variant="body1" paragraph>
//               <strong>LLM Insight</strong> is a{" "}
//               <strong>cutting-edge AI governance platform</strong> built to{" "}
//               <strong>
//                 monitor, manage, and optimize Large Language Models (LLMs)
//               </strong>{" "}
//               with precision.
//             </Typography>
//             <Typography variant="body1" paragraph>
//               Our mission is to <strong>simplify LLM governance</strong> for
//               businesses by providing:
//             </Typography>
//             <ul>
//               <li>📊 Real-time analytics for AI usage & performance.</li>
//               <li>💰 Automated cost tracking to prevent overspending.</li>
//               <li>🔄 A unified chat interface for multiple LLM providers.</li>
//               <li>⚙️ Scalability & modularity through microservices.</li>
//               <li>📂 Centralized logging for auditing & compliance.</li>
//             </ul>
//           </Grid2>
//         </Grid2>
//       </Container>

//       {/* Why Choose LLM Insight */}
//       <Container maxWidth="md" sx={{ py: 4, color: "#002367" }}>
//         <Typography variant="h4" gutterBottom>
//           Why Choose LLM Insight?
//         </Typography>
//         <Typography variant="body1" paragraph>
//           <strong>LLM Insight</strong> provides a{" "}
//           <strong>powerful AI governance framework</strong>, ensuring that your
//           AI systems are{" "}
//           <strong>cost-effective, secure, and seamlessly integrated</strong>.
//         </Typography>
//         <ul>
//           <li>
//             📊 Cost Monitoring & Budget Control - Track expenses in real-time.
//           </li>
//           <li>
//             🔒 Security & Compliance - Integrated with Active Directory for
//             role-based access.
//           </li>
//           <li>
//             🖥️ Single Chat Window - Unified interface for all LLM providers.
//           </li>
//           <li>
//             ⚙️ Microservices Architecture - Ensures scalable AI model
//             deployments.
//           </li>
//           <li>
//             📂 Centralized LLM Usage Logs - Maintain detailed records for
//             audits.
//           </li>
//         </ul>
//       </Container>

//       {/* Our Valuable Clients */}
//       <Box sx={{ flexGrow: 1, width: "100%", py: 4 }}>
//         <Typography
//           sx={{
//             color: "#002367",
//             fontSize: { xs: 24, sm: 32, md: 42 },
//             fontWeight: "700",
//             lineHeight: "35px",
//             textAlign: "center",
//             my: 4,
//           }}
//         >
//           Our Valuable Clients
//         </Typography>
//         <ClientCards />
//       </Box>
//     </Box>
//   );
// };

// export default AboutUs;
